import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo, useCallback } from 'react';
import { propFunc, propNumber, } from '../../../../../../../helpers/custom-prop-types';
const QuestionTab = (props) => {
    const { activeTabIndex, allCount, changeTabIndex, inputCount, noInputCount } = props;
    const items = useMemo(() => [
        {
            active: activeTabIndex === 1,
            count: allCount,
            id: 1,
            label: 'すべて',
        },
        {
            active: activeTabIndex === 2,
            count: noInputCount,
            id: 2,
            label: '未回答',
        },
        {
            active: activeTabIndex === 3,
            count: inputCount,
            id: 3,
            label: '回答済',
        },
    ], [activeTabIndex, allCount, noInputCount, inputCount]);
    const onClick = useCallback((e) => {
        changeTabIndex(parseInt(e.currentTarget.value, 10));
    }, [changeTabIndex]);
    return (_jsx("div", Object.assign({ className: 'rfp_question_tab_head' }, { children: _jsx("ul", Object.assign({ className: 'rfp_question_tab_head_item_list' }, { children: items.map((item) => (_jsx("li", Object.assign({ className: clsx('rfp_question_tab_head_item', item.active && 'is_active') }, { children: _jsxs("button", Object.assign({ className: 'rfp_question_tab_head_button', onClick: onClick, type: 'button', value: item.id }, { children: [`${item.label}（${item.count}件）`, _jsx("i", { className: 'arrow_down' })] })) }), item.id))) })) })));
};
QuestionTab.propTypes = {
    activeTabIndex: propNumber().isRequired,
    allCount: propNumber().isRequired,
    changeTabIndex: propFunc().isRequired,
    inputCount: propNumber().isRequired,
    noInputCount: propNumber().isRequired,
};
export default QuestionTab;
